import {useEffect, useCallback} from "react";
import {batch, useComputed, useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {USER_ROLES, GROUPED_BY, WEBBACK_V2_API } from "@constants";
import {useToast, useUserApp} from "@hooks";
import {isLoadingCommonFilters, commonFiltersValue, splitKpi, isSystemBusy} from "@signals";
import { TABS_TABLE } from "../@contants";
import {PriceEvolutionCurrentTabId, PriceEvolutionCurrentTabLabel, PriceEvolutionTabsTableID} from "../@signals";


export default function usePriceEvolutionTablePricing() {
	const { showToast } = useToast()
	const { userRole } = useUserApp()

	const localLoading = useSignal(false)
	const data = useSignal([])
	const allData = useSignal({})

	const isLoading = useComputed(() => isLoadingCommonFilters.value || localLoading.value)
	const selectedLabel = useComputed(() => isLoading.value ? null : PriceEvolutionCurrentTabLabel.value)

	useEffect(() => {
		if (isLoading.value && isLoadingCommonFilters.value) {
			allData.value = {}
			data.value = {}
			handleSubmit()
		}
	}, [isLoading.value]);

	useEffect(() => {
		if (PriceEvolutionCurrentTabId.value && !isLoading.value && !(PriceEvolutionCurrentTabId.value in allData.value))
			handleSubmit(true)
		else
			data.value = allData.value[PriceEvolutionCurrentTabId.value]
	}, [PriceEvolutionCurrentTabId.value]);

	const saveAllData = (res) => {
		if (res?.length) {
			let tabID = null
			if (splitKpi.value === GROUPED_BY.SKU) {
				tabID = res[0].skuID
			} else {
				tabID = res[0].siteID
			}
			
			if (!(tabID in allData.value)) {
				allData.value[tabID] = res
			}
		}
	}	

	const handleSubmit = (useTab=false) => {
		const filters = {...commonFiltersValue.value}
		if (useTab) {
			if (splitKpi.value[0] === GROUPED_BY.SKU || splitKpi.value === GROUPED_BY.SKU) {
				filters.sku = [PriceEvolutionCurrentTabId.value]
			} else {
				filters.retailer = [PriceEvolutionCurrentTabId.value]
			}
		}

		if (!localLoading.value)
			localLoading.value = true

		postSubmit(`${WEBBACK_V2_API}/pricing/price-evolution/table-pricing-new`, {
			...filters,
		}).then(res => batch(() => {
			localLoading.value = false
			data.value = res
			saveAllData(res)
			if(!PriceEvolutionTabsTableID.value && res?.length)
				PriceEvolutionTabsTableID.value = TABS_TABLE.PRICING
		})).catch(() => batch(() => {
			localLoading.value = false
			isSystemBusy.value = true
		}))
	}

	const handleExcel = useCallback(() => showToast.promiseExcel(
		`${WEBBACK_V2_API}/pricing/price-evolution/table-pricing-new/excel/${PriceEvolutionCurrentTabId.value}`, {
			...commonFiltersValue.value,
			splitKpi: Array.isArray(splitKpi.value) ? splitKpi.value[0] : splitKpi.value
		}, null, {
			onError: data => {
				if (data.toString().includes('Error')) return 'Excel file size exceeded'
			}
		}), [])

	return {
		isLoading: isLoading.value,
		data: data.value,
		allData: allData.value,
		selectedLabel: selectedLabel.value,

		isStandardUser: userRole === USER_ROLES.STANDARD,
		isRetailerUser: userRole === USER_ROLES.RETAILER,

		handleExcel
	}

}